<section>
  <ul class="tabs-menu">
    <li><a [routerLink]="authorInfoLink" [routerLinkActive]="['active']">Author Info</a></li>
    <li><a [routerLink]="authorProfileLink" [routerLinkActive]="['active']">Author Profile</a></li>
    <li><a [routerLink]="contactInfoLink" [routerLinkActive]="['active']">Contact Info</a></li>
    <li><a [routerLink]="changePasswordLink" [routerLinkActive]="['active']">Login & Security</a></li>
    <li><a [routerLink]="billingLink" [routerLinkActive]="['active']">Billing & Orders</a></li>
  </ul>
</section>
